import { Injectable } from '@angular/core';
import { FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { getDefaultControlValue, regonValidator } from '@gk/gk-modules';
import { ECSControlName } from '../../../../components/electronic-correspondence-statement/models/form/form.model';
import { BaseNewRequestFormService } from '../../../../shared/base-new-request-form/base-new-request-form.service';
import {
  INWEPCombustionSourceControlName,
  INWEPCombustionSourceFormGroup,
  INWEPNewRequestControlName,
  INWEPNewRequestFormGroup,
} from './new-request-form.model';

@Injectable()
export class INWEPNewRequestFormService {
  constructor(
    private formBuilder: UntypedFormBuilder,
    private baseNewRequestFormService: BaseNewRequestFormService,
  ) {}

  getFormGroup(): FormGroup<INWEPNewRequestFormGroup> {
    return this.formBuilder.group({
      ...this.baseNewRequestFormService.getCommonInvestorFormGroup(
        {
          [ECSControlName.ElectronicCorrespondenceStatement]: false,
        },
        {
          addressFormGroupBasedOnSelectControls: true,
          disableAddressFormInNaturalPersonGroup: true,
        },
      ).controls,
      [INWEPNewRequestControlName.ActivityDescription]:
        this.formBuilder.control(getDefaultControlValue(), Validators.required),
      [INWEPNewRequestControlName.InstallationOperatingTime]:
        this.formBuilder.control(getDefaultControlValue(), Validators.required),
      [INWEPNewRequestControlName.EmissionTypeAndAmount]:
        this.formBuilder.control(getDefaultControlValue(), Validators.required),
      [INWEPNewRequestControlName.EmissionReductionMethods]:
        this.formBuilder.control(getDefaultControlValue(), Validators.required),
      [INWEPNewRequestControlName.ReductionCompliantDescription]:
        this.formBuilder.control(getDefaultControlValue(), Validators.required),
      [INWEPNewRequestControlName.IsCombustionSourceRequired]:
        this.formBuilder.control(getDefaultControlValue()),
    });
  }

  getCombustionSourceFormGroup(): FormGroup<INWEPCombustionSourceFormGroup> {
    const formGroup = this.formBuilder.group({
      [INWEPCombustionSourceControlName.BusinessActivityCode]:
        this.formBuilder.control(getDefaultControlValue(), Validators.required),
      [INWEPCombustionSourceControlName.Regon]: this.formBuilder.control(
        getDefaultControlValue(),
        [Validators.required, regonValidator()],
      ),
      [INWEPCombustionSourceControlName.CombustionPower]:
        this.formBuilder.control(getDefaultControlValue(), Validators.required),
      [INWEPCombustionSourceControlName.CombustionSourceType]:
        this.formBuilder.control(getDefaultControlValue(), Validators.required),
      [INWEPCombustionSourceControlName.FuelShareType]:
        this.formBuilder.control(getDefaultControlValue(), Validators.required),
      [INWEPCombustionSourceControlName.EmissionStandards]:
        this.formBuilder.control(getDefaultControlValue(), Validators.required),
      [INWEPCombustionSourceControlName.CommissionDate]:
        this.formBuilder.control(getDefaultControlValue(), Validators.required),
      [INWEPCombustionSourceControlName.LoadTimeDescription]:
        this.formBuilder.control(getDefaultControlValue(), Validators.required),
      [INWEPCombustionSourceControlName.CommissionDateUnknown]:
        this.formBuilder.control(getDefaultControlValue()),
    });

    const commissionDateUnknownFormControl = formGroup.get(
      INWEPCombustionSourceControlName.CommissionDateUnknown,
    );
    const commissionDateFormControl = formGroup.get(
      INWEPCombustionSourceControlName.CommissionDate,
    );
    commissionDateUnknownFormControl?.valueChanges.subscribe((isUnknown) => {
      if (isUnknown) {
        commissionDateFormControl?.setValue(null);
        commissionDateFormControl?.disable();
      } else {
        commissionDateFormControl?.enable();
      }
    });

    return formGroup;
  }
}
